import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import './fullScreenPopup.scss';

interface FullScreenPopupProps {
  isOpen: boolean;
  children: ReactNode;
}

const FullScreenPopup: React.FC<FullScreenPopupProps> = ({ isOpen, children }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="popup-overlay">
      <div className="popup-content">
        {children}
      </div>
    </div>,
    document.body
  );
};

export default FullScreenPopup;
